import React from "react";
import PropTypes from "prop-types";
import { PiSelectionSlashBold } from "react-icons/pi";
import { useTranslation } from "react-i18next";
import "./FloatingBar.scss";

const FloatingBar = ({
	selectedCount,
	onClear,
	isSidebarDragging = false,
	showActions = false,
	onExchange,
	onLock,
	onUnlock,
	onRemove,
	showExchange = false,
	showReopenAbsence = false,
	onReopenAbsence,
}) => {
	const { t } = useTranslation();
	const shouldShow = selectedCount > 0 && !isSidebarDragging;

	return (
		<div
			className={`floating-bar ${shouldShow ? "visible" : "hidden"}`}
			role="status"
			aria-live="polite"
			aria-hidden={!shouldShow}
		>
			<div className="floating-bar-info">
				<span className="selection-count">
					{t('floatingBar.selectedCount', { count: selectedCount })}
				</span>
				<span className="separator" aria-hidden="true">
					·
				</span>
				<button type="button" className="button-link primary" onClick={onClear}>
					<PiSelectionSlashBold /> {t('floatingBar.clearSelection')}
				</button>
			</div>

			{showActions && (
				<div className="floating-bar-actions">
					{showExchange && (
						<button type="button" className="btn btn-action" onClick={onExchange}>
							{t('floatingBar.exchange')}
						</button>
					)}
					{showReopenAbsence && (
						<button
							type="button"
							className="btn btn-action"
							onClick={onReopenAbsence}
						>
							{t('absences.reopenAbsence')}
						</button>
					)}
					<button type="button" className="btn btn-action" onClick={onLock}>
						{t('floatingBar.lock')}
					</button>
					<button type="button" className="btn btn-action" onClick={onUnlock}>
						{t('floatingBar.unlock')}
					</button>
					<span className="action-divider" aria-hidden="true" />
					<button
						type="button"
						className="btn btn-action btn-action-danger"
						onClick={onRemove}
					>
						{t('common.delete')}
					</button>
				</div>
			)}
		</div>
	);
};

FloatingBar.propTypes = {
	selectedCount: PropTypes.number.isRequired,
	onClear: PropTypes.func.isRequired,
	isSidebarDragging: PropTypes.bool,
	showActions: PropTypes.bool,
	onExchange: PropTypes.func,
	onLock: PropTypes.func,
	onUnlock: PropTypes.func,
	onRemove: PropTypes.func,
	showExchange: PropTypes.bool,
	showReopenAbsence: PropTypes.bool,
	onReopenAbsence: PropTypes.func,
};

FloatingBar.defaultProps = {
	isSidebarDragging: false,
	showActions: false,
	showExchange: false,
	showReopenAbsence: false,
};

export default FloatingBar;
